export default __webpack_public_path__ + "static/media/Badge.e506ca4c.png";